// extracted by mini-css-extract-plugin
export default {"activator":"ColorInput_activator_JEBvn","activatorInner":"ColorInput_activatorInner_kwQKl"};